module.exports = __webpack_public_path__ + "static/media/pantalla-login-admin.8ba9a5e0.png";